export const graphOptions: {
	field: 'total_runs' | 'total_runtime' | 'average_runtime';
	title: string;
}[] = [
	{
		field: 'total_runs',
		title: 'Total Runs',
	},
	{
		field: 'total_runtime',
		title: 'Total Runtime',
	},
	{
		field: 'average_runtime',
		title: 'Average Runtime',
	},
];
